import React, { useEffect, useState } from "react";
import { retryPayment } from '../../../slices/payments'
import { updateAddress, createAddress } from "../../../slices/address";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from "react-router-dom";
import { PaymentStatus } from "../../../components/status";
import { Button } from "../../../components/button";
import { SvgArrow, SvgCancel, SvgReceipt, SvgRecycleBin, SvgSinglePayments } from "../../../components/svg";
import { TransactionTable } from "../../../components/table/table_transactionslist";
import { WebhookTable } from "../../../components/table/table_webhooktable";
// import { ActionTable } from "../../../components/table/table_actiontable";
import PaymentForm from "../../../components/forms/payment-form";
import { SaveIndicator } from "../../../components/save-indicator";
import useModal from "../../../hooks/modal";
import Modal from "../../../components/modal";
import BasicAddressForm from "../../../components/forms/basic-address-form";
import moment from 'moment';
import { AuditLogTable } from "../../../components/table/table_auditloglist";
import { formatMoney, getDate } from "../../../utils";
import { CustomerDetailsCard } from "../../../components/customer_details_card";

const translations = [
    gettext('Close'),
    gettext('Something went wrong while processing this request. If this error persists, please contact support for assistance.'),
    gettext('Reference'),
    gettext('Created at'),
    gettext('Amount'),
    gettext('Description'),
    gettext("Retry"),
    gettext('Confirm'),
    gettext('Are you sure you want to retry this payment? You can only try each payment a limited number of times.'),
    gettext("Customer"),
    gettext("Customer"),
    gettext("Transactions"),
    gettext("No transactions were found for this payment"),
    gettext("All transactions"),
    gettext("History"),
    gettext("No actions were found for this payment"),
    gettext("Full history"),
    gettext("Webhooks"),
    gettext("No webhooks were found for this payment"),
    gettext("All webhooks"),
    gettext("History for payment"),
]

function PaymentDetail() {
    let { paymentId } = useParams();
    const dispatch = useDispatch()

    const selectedPayment = useSelector((state) => state.payments.selectedPayment)
    const loadingDetail = useSelector((state) => state.payments.loadingDetail)
    const loadingUpdate = useSelector((state) => state.payments.loadingUpdate)

    const [isShowingRetry, toggleRetry] = useModal();
    const [isShowingErrorModal, toggleErrorModal] = useModal();


    const retry = () => {
        dispatch(retryPayment({ paymentId: paymentId, args: {} }))
            .then((item) => {
                if (item.error) {
                    toggleErrorModal(true)
                }
                toggleRetry()
            });
    }

    const renderFirstName = () => {
        if (selectedPayment.customer.name) {
            let parts = selectedPayment.customer.name.split(" ")
            if (parts.length > 0) {
                return parts[0]
            } else {
                return selectedPayment.customer.name
            }
        }
        return ''
    }


    const ErrorModal = () => {
        return (
            <Modal
                show={isShowingErrorModal}
                onClose={toggleErrorModal}
                icon={<SvgCancel />}
                onClick={() => toggleErrorModal(false)}
                confirmButtonText={gettext('Close')}
                showCancelButton={false}
            >
                <p><strong>{gettext('Something went wrong while processing this request. If this error persists, please contact support for assistance.')}</strong></p>
            </Modal>
        )
    }

    return (
        <>
            {selectedPayment &&
                <>
                    {loadingDetail ?
                        <div className="loader top-50 start-50 position-absolute" role="status"></div>
                        :
                        <>
                            <div className="container-fluid">
                                <ErrorModal></ErrorModal>
                                <div className="row">
                                    <div className="col px-0 d-flex justify-content-between align-items-center">
                                        <h1 className="title">{renderFirstName()} {selectedPayment.customer.last_name}</h1>
                                        <SaveIndicator isSaving={loadingUpdate} />
                                    </div>
                                </div>
                            </div>
                            <div className="contentarea">
                                <div className="container-fluid detail">
                                    <div className="row">
                                        <div className="col-12 mb-4">
                                            <PaymentStatus key={paymentId} payment={selectedPayment} />
                                        </div>
                                    </div>
                                    <div className="row mb-4">
                                        <div className="col-5 mb-3">
                                            <label>{gettext('Reference')}</label>
                                            <p>{selectedPayment.reference ? selectedPayment.reference : '-'}</p>
                                        </div>
                                        <div className="col-4 mb-3">
                                            <label>{gettext('Created at')}</label>
                                            <p>{getDate(selectedPayment.created_at, true)}</p>
                                        </div>
                                        <div className="col-3 mb-3 text-end">
                                            <label>{gettext('Amount')}</label>
                                            <p>{selectedPayment.currency} {formatMoney(selectedPayment.amount)}</p>
                                        </div>
                                        {selectedPayment.description &&
                                            <div className="col-12 mb-3">
                                                <label>{gettext('Description')}</label>
                                                <p>{selectedPayment.description}</p>
                                            </div>
                                        }
                                    </div>
                                    <div className="row justify-content-end">
                                        {selectedPayment.retry_allowed &&
                                            <>
                                                <div className="col-sm-4 mb-4 align-self-end">
                                                    <Button variant={"secondary"} formControl={true} onClick={() => toggleRetry()} icon={<SvgSinglePayments />}>{gettext("Retry")}</Button>
                                                    <Modal
                                                        show={isShowingRetry}
                                                        onClose={toggleRetry}
                                                        icon={<SvgSinglePayments />}
                                                        onClick={() => retry()}
                                                        confirmButtonText={gettext('Confirm')}
                                                    >
                                                        <p><strong>{gettext('Are you sure you want to retry this payment? You can only try each payment a limited number of times.')}</strong></p>
                                                    </Modal>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>

                                <div className="container-fluid related">
                                    <div className="row">
                                        <div className="col mb-4">
                                            <h2>{gettext("Customer")}</h2>
                                            <CustomerDetailsCard customer={selectedPayment.customer} />
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col">
                                            <h2>{gettext("Transactions")}</h2>
                                            <div className="table-wrapper mb-3 overflow-scroll">
                                                {selectedPayment.transactions && selectedPayment.transactions.length > 0 ?
                                                    <TransactionTable filters={[{ payment_id: selectedPayment.id }]} size={'sm'} limit={5} hideFilters={true} />
                                                    :
                                                    <p>{gettext("No transactions were found for this payment")}</p>
                                                }
                                            </div>
                                            {selectedPayment.transactions && selectedPayment.transactions.length > 0 &&
                                                <div className="text-end">
                                                    <Button variant={"secondary"} size={'sm'}>{gettext("All transactions")}</Button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col">
                                            <h2>{gettext("History for payment")}</h2>
                                            <div className="table-wrapper mb-3 overflow-scroll">
                                                {selectedPayment.audit_logs && selectedPayment.audit_logs.length > 0 ?
                                                    <AuditLogTable data={selectedPayment.audit_logs} />
                                                    :
                                                    <p>{gettext("No actions were found for this payment")}</p>
                                                }
                                            </div>
                                            {selectedPayment.actions && selectedPayment.actions.length > 0 &&
                                                <div className="text-end">
                                                    <Button variant={"secondary"} size={'sm'}>{gettext("Full history")}</Button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col">
                                            <h2>{gettext("Webhooks")}</h2>
                                            <div className="table-wrapper mb-3 overflow-scroll">
                                                {selectedPayment.latest_webhooks && selectedPayment.latest_webhooks.length > 0 ?
                                                    <WebhookTable data={selectedPayment.latest_webhooks || []} size={'sm'} />
                                                    :
                                                    <p>{gettext("No webhooks were found for this payment")}</p>
                                                }
                                            </div>
                                            {selectedPayment.latest_webhooks && selectedPayment.latest_webhooks.length > 0 &&
                                                <div className="text-end">
                                                    <Button variant={"secondary"} size={'sm'}>{gettext("All webhooks")}</Button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </>
    )

}

export default PaymentDetail